import { eventBus, EnumEventBus } from "./EventBus";
import BaseAngleManager from "../../../../../src/managers/BaseAngleManager";
import { AngleProps, Coord } from "../../../../../src/types/Interface";
import { generateAngles } from "../../../../../src/utils/generator/generateAngles";
import { PINK_ANGLE_COLORS, BLUE_ANGLE_COLORS } from "../types/Config";


const pAC = PINK_ANGLE_COLORS;
const bAC = BLUE_ANGLE_COLORS;
const anglePropsArr: AngleProps[] = Array(4)
  .fill(null)
  .map((_, i) => ({ angleColors: { color: i > 1 ? bAC[0] : pAC[0], textColor: i > 1 ? bAC[1] : pAC[1] }, smallDistanceOffset: 100 }))


export default class AngleManager extends BaseAngleManager {
  constructor() {
    super(anglePropsArr)

    eventBus.on(EnumEventBus.catMode, v => setTimeout(() => this.setAllVisible(!v), v ? 0 : 300));
  }

  draw(points: Coord[], clockwises: boolean[], isShownSecondAngles:boolean) {
    Array(2).fill(null).forEach((_, aI) => {
      const P = { curr: points[aI], prev: points[2], next: points[3] };
      const degree = generateAngles(P, !clockwises[aI]).degree;
      this.drawAngle(this.Angles[aI], P, degree, clockwises[aI]);
    });


    this.Angles[2].setVisible(isShownSecondAngles);
    this.Angles[3].setVisible(isShownSecondAngles);
    if (isShownSecondAngles) {
      const cw = [clockwises[1], clockwises[0]];
      Array(2).fill(null).forEach((_, aI) => {
        const P = { curr: points[aI + 2], prev: points[1], next: points[0] };
        const degree = generateAngles(P, cw[aI]).degree;
        this.drawAngle(this.Angles[aI + 2], P, degree, !cw[aI]);
      })
    }
  }
}